<template>
  <section>
    <div class="photos" v-for='(value,key) in model' :key="key">
        <div><order-module-title :title="key"/></div>
        <div class="info">
          <img v-for='(item,index) in value' :key="index" v-lazy="formatImgUrl(item,300,240)" @click='preview(index,value,key)'/>
        </div>
    </div>
    <previewer ref="previewer"></previewer>
  </section>
</template>

<script>
  export default {
    name: 'photos',
    computed: {
      defaultImg () {
        return this.DEFAULT_IMG
      }
    },
    props : {
      model : {
        type : Object,
        default : () => {}
      }
    },
    methods : {
      formatImgUrl(url, width, height,m_fill) {
        // console.log(url)
        if (url) {
          url = url.replace('h_{height},w_{width}', "h_" + height + ",w_" + width + "");
          // url = url.replace(',jpg', ",webp");
          url +=',q_80';
          if(m_fill){
            // console.log(m_fill)
            url = url.replace('m_lfit', "m_fill");
          }
        }
        return url
      },
      preview(index,list,title){
        this.$refs.previewer.show(index, list,title)
      },
    }
  }
</script>

<style scoped lang="scss">
  .photos{
    &>div{
      display: flex;
      justify-content: center;
      &.info{
        padding: 0 30px 30px 50px;
        padding-left: 20px;
        display: flex;
        flex-wrap: wrap;
        justify-content: normal;
        margin-top: 30px;
        img{
          width: 204px;
          height: 204px;
          margin: 0 20px 20px 0;
          &:nth-child(3n){
            margin-right: 0;
          }
        }
      }
    }
  }
</style>
